// Fail closed on malformed response shapes; never render arbitrary record fields.
function safeAuthor(value) {
  return typeof value === 'string' && value.indexOf('@') === -1 ? value.trim() : '';
}

function safeQuoteAttributions(quotes) {
  if (!Array.isArray(quotes)) return [];
  return quotes.filter(quote => quote && typeof quote === 'object'
    && (typeof quote.id === 'number' || typeof quote.id === 'string')
    && typeof quote.quote === 'string' && quote.quote.trim())
    .map(quote => ({
      id: quote.id, quote: quote.quote, quoteAuthor: safeAuthor(quote.quoteAuthor),
    }));
}

function safeArtworkCredit(credit) {
  if (!credit || typeof credit !== 'object' || typeof credit.title !== 'string') return null;
  const author = safeAuthor(credit.author);
  return credit.title.trim() && author ? { title: credit.title, author } : null;
}

export { safeQuoteAttributions, safeArtworkCredit };
